export default __webpack_public_path__ + "static/media/megane-gallery-2.b6ffe945.jpg";